import { Anchor, Text } from "@mantine/core";

import styles from "./logo.module.css";

export const Logo = () => {
    return (
        <Anchor href="/" className={styles.logo} unstyled>
            <Text component="span" className={styles.logoText} c="#c9c9c9">
                Online
                <br />
                <span>Escape Room</span>
            </Text>
        </Anchor>
    );
};
